import { startCase } from "lodash";
import { FC } from "react";

import { TDrawerCloseFunction } from "@ryde/shared";

import { LayoutRightHeaderTitleStyled } from "../../../right";
import { DrawerCloseIconButton } from "./close-icon-button";
import { DrawerHeaderStyled } from "./header.styled";

interface IDrawerHeaderWithSubtitleProps {
  title: string;
  subTitle?: string;
  onCloseDrawer: TDrawerCloseFunction;
}

export const DrawerHeaderWithSubtitle: FC<IDrawerHeaderWithSubtitleProps> = ({
  title,
  subTitle,
  onCloseDrawer,
}) => {
  return (
    <DrawerHeaderStyled>
      <DrawerCloseIconButton onCloseDrawer={onCloseDrawer} />
      <LayoutRightHeaderTitleStyled className="DrawerHeaderTitle">
        {startCase(title)}
        {subTitle && <span className="sub_header">{subTitle}</span>}
      </LayoutRightHeaderTitleStyled>
    </DrawerHeaderStyled>
  );
};
